import { render, staticRenderFns } from "./component2.vue?vue&type=template&id=1d894c5b&scoped=true&"
import script from "./component2.vue?vue&type=script&lang=js&"
export * from "./component2.vue?vue&type=script&lang=js&"
import style0 from "./component2.vue?vue&type=style&index=0&id=1d894c5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d894c5b",
  null
  
)

export default component.exports